module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/stripe-cb5ccb224f623e2fba24eb9838612cb7.svg";